import { Box, Typography } from "@mui/material";
import ServingAmountsSmallChipList from "../SmallChipList";
import { RecipeWithServingsFragment } from "../../../../types";

interface MealPlanExportAppendixRecipeProps {
  recipe: RecipeWithServingsFragment;
}

const MealPlanExportAppendixRecipe = ({ recipe }: MealPlanExportAppendixRecipeProps) => {
  // Pretend all ingredients are just foods and not recipes so recipes don't need to have their own ingredients on them
  const ingredients = recipe.ingredients.map(({ serving: { foodOrRecipe, ...serving }, ...ingredient }) => ({
    ...ingredient,
    serving: {
      ...serving,
      foodOrRecipe: {
        ...foodOrRecipe,
        choPer100g: 0,
        proPer100g: 0,
        fatPer100g: 0,
        kcalPer100g: 0,
        exchangeTypes: [],
        isRecipeIngredientOnly: false,
        usdaFdcDescription: null,
        usdaFdcId: null,
        nixItemId: null,
        nixTagId: null,
        usdaFdcDataType: null,
        usdaFdcFoodCategoryId: null,
        exchangeAmountRatios: [],
        __typename: "GenericFood" as "GenericFood",
        thumbnailUrl: "",
        hasFullAccess: true,
        org: null,
      },
      customUnits: "",
      unitPrefix: null,
      unitSuffix: null,
      unit: null,
    },
  }));

  const stepsComponent =
    recipe.steps && recipe.steps.length ? (
      <Box>
        <Typography variant="body2Medium">Directions</Typography>
        {recipe.steps.map((step, index) => (
          <Typography key={`${recipe.id}${index}`} variant="subtitle1">
            {`${index + 1}. ${step}`}
          </Typography>
        ))}
      </Box>
    ) : undefined;

  const noteComponent = recipe.note && (
    <Typography variant="subtitle1">
      <strong>*</strong>
      {recipe.note}
    </Typography>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: "600px", p: 1, pb: 0 }}>
      <Typography variant="h4">{recipe.name}</Typography>
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <Box sx={{ width: "30%", display: "flex", flexDirection: "column", }}>
          <Typography variant="body2Medium">Ingredients</Typography>
          <ServingAmountsSmallChipList
            expandRecipes={false}
            servingAmounts={ingredients}
            recipes={[recipe]} />
        </Box>
        <Box sx={{ width: "64.5%", fontSize: "14px", display: "flex", flexDirection: "column", pl: 2 }}>
          {stepsComponent}
        </Box>
      </Box>
      <Box sx={{ width: "100%", pt: 1 }}>{noteComponent}</Box>
    </Box>
  );
};

export default MealPlanExportAppendixRecipe;
